export { useFSTrackEvent } from '@dc-shared-web/hooks/api/analytic/useFSTrackEvent'
export { useTrackEvent } from '@dc-shared-web/hooks/api/analytic/useTrackEvent'
